module.exports = __webpack_public_path__ + "img/no_history_goals.63ca517e.svg";